module.exports = __webpack_public_path__ + "img/ot-joe-avaxusdc.c95d38ab.png";